export default __webpack_public_path__ + "static/media/productboard.b08c436a.svg";